import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {TombOfAkhenatenFontConfig} from "./TombOfAkhenatenFontConfig";
import {TombOfAkhenatenGameAssets} from "./TombOfAkhenatenGameAssets";
import {TombOfAkhenatenGameConfig} from "./TombOfAkhenatenGameConfig";
import {TombOfAkhenatenSoundConfig} from "./TombOfAkhenatenSoundConfig";
import {TombOfAkhenatenServerDataParser} from "./server/TombOfAkhenatenServerDataParser";
import {TombOfAkhenatenParsedGameData} from "./server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "./server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenReelSymbol} from "./symbols/TombOfAkhenatenReelSymbol";
import {TombOfAkhenatenReelSymbolStateCreator} from "./symbols/TombOfAkhenatenReelSymbolStateCreator";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {SpinStart} from "./gameround/spin/SpinStart";
import {ReelStart} from "./gameround/reel/ReelStart";
import {SpinStop} from "./gameround/spin/SpinStop";
import {ReelStop} from "./gameround/reel/ReelStop";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TombOfAkhenatenReelController} from "./reel/TombOfAkhenatenReelController";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {TombOfAkhenatenGameMode} from "./gameMode/TombOfAkhenatenGameMode";
import {TombOfAkhenatenBackgroundView} from "./backgroundView/TombOfAkhenatenBackgroundView";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {TombOfAkhenatenReelAreaView} from "./reel/TombOfAkhenatenReelAreaView";
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {TombOfAkhenatenFreeSpinIntroView} from "./transitions/TombOfAkhenatenFreeSpinIntroView";
import {TombOfAkhenatenFreeSpinOutroView} from "./transitions/TombOfAkhenatenFreeSpinOutroView";
import {TOALowSymbol} from "./symbols/TOALowSymbol";
import {TOAMultiplier} from "./multiplier/TOAMultiplier";
import {NormalWin} from "./gameround/NormalWin";
import {TOAInitialWinCountUp} from "./winpresentation/initial/TOAInitialWinCountUp";
import {WinTextView} from "./gameround/WinTextView";
import {CountUpView} from "./gameround/CountUpView";
import {BigWinStep} from "./gameround/bigWinStep";
import {TombOfAkhenatenZeroBet} from "./gameround/TombOfAkhenatenZeroBet";
import {WinEnd} from "./gameround/WinEnd";
import {BetWayWin} from "./gameround/betWayWin/betWayWin";
import {StonePress} from "./gameround/stonePress/StonePress";
import {StonePressView} from "./gameround/stonePress/StonePressView";
import {TOAWildSymbol} from "./symbols/TOAWildSymbol";
import {TOAScatterSymbol} from "./symbols/TOAScatterSymbol";
import {TOAScatterOverlayView} from "./symbols/TOAScatterOverlayView";
import {WaysUpdateView} from "./gameround/stonePress/waysUpdateView";
import {ReelDividerView} from "./reel/ReelDividerView";
import {TOASymbolStateHandler} from "./gameround/stonePress/TOASymbolStateHandler";
import {SymbolsFireOverlayView} from "./symbols/SymbolsFireOverlayView";
import {TOASymbolIdleAnimController} from "./winpresentation/idle/TOASymbolIdleAnimController";
import {TOABackgroundIdleAnimController} from "./winpresentation/idle/TOABackgroundIdleAnimController";
import {TOAShakeEffect} from "./winpresentation/TOAShakeEffect/TOAShakeEffect";
import {TOANearWin} from "./gameround/nearWin/TOANearWin";
import {TOAGameModeTransitionControllerWithView} from "./transitions/TOAGameModeTransitionControllerWithView";
import {TOATimelineReelsController} from "./reel/TOATimelineReelsController";
import {SoundManager} from "./sound/SoundManager";
import {SpinningPyramidController} from "./feature/SpinningPyramidController";
import {FeaturePrice} from "./server/data/FeaturePrice";
import {BetWayWinInitial} from "./gameround/betWayWin/betWayWinInitial";
import {TOAWinFieldController} from "./winpresentation/initial/TOAWinFieldController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class TombOfAkhenatenGameModuleConfig implements IGameModuleConfig {

    public static instance: TombOfAkhenatenGameModuleConfig = new TombOfAkhenatenGameModuleConfig();
    public static reelDividerView: ReelDividerView;
    public static symFireOverlay: SymbolsFireOverlayView;
    public static toaMultiplier: TOAMultiplier;
    public static toaWinCountUp: TOAInitialWinCountUp;
    public static toaCountupView: CountUpView;
    public static toaBigWinView: WinTextView;
    public static symbolStateHandler: TOASymbolStateHandler;
    private static gameTweakerTest: GameTweakerTest;
    private static background: StillImageBackground;
    private static shake: TOAShakeEffect;
    private static soundManager: SoundManager;
    public static featurePrice: FeaturePrice;

    public static reelArr : number[][] = [
        [0,1,2,3,4],
        [5,6,7,8,9],
        [10,11,12,13,14],
        [15,16,17,18,19],
        [20,21,22,23,24],
    ]
    public static pyramidWildExpandingDuration : number = 0.8;
    public static canPyramidStopParallelly : boolean = true;

    GAME_CONFIG: IGameConfig = TombOfAkhenatenGameConfig.instance;
    SOUND_CONFIG: ISoundConfig = TombOfAkhenatenSoundConfig.instance;
    FONTS_CONFIG: IFontsConfig = TombOfAkhenatenFontConfig.FONTS;
    RESOURCES_CONFIG: IResourcesGroupConfig = TombOfAkhenatenGameAssets.RESOURCES_GROUPS;

    GAME_MODE_TRANSITIONS?: (() => GameModeTransitionController)[] = [
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.NORMAL,
                TombOfAkhenatenGameMode.RESPIN_FIRST
            );
        },
        () => {
            return new TOAGameModeTransitionControllerWithView(
                [TombOfAkhenatenGameMode.NORMAL, TombOfAkhenatenGameMode.RESPIN_FIRST, TombOfAkhenatenGameMode.RESPIN_SECOND, TombOfAkhenatenGameMode.RESPIN_FINAL],
                TombOfAkhenatenGameMode.FREESPIN,
                new TombOfAkhenatenFreeSpinIntroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.RESPIN_FIRST,
                TombOfAkhenatenGameMode.RESPIN_SECOND
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.RESPIN_FIRST,
                TombOfAkhenatenGameMode.NORMAL
            );
        },
        () => {
            return new TOAGameModeTransitionControllerWithView(
                [TombOfAkhenatenGameMode.RESPIN_FIRST, TombOfAkhenatenGameMode.NORMAL, TombOfAkhenatenGameMode.RESPIN_SECOND, TombOfAkhenatenGameMode.RESPIN_FINAL],
                TombOfAkhenatenGameMode.FREESPIN,
                new TombOfAkhenatenFreeSpinIntroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.RESPIN_SECOND,
                TombOfAkhenatenGameMode.RESPIN_FINAL
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.RESPIN_SECOND,
                TombOfAkhenatenGameMode.NORMAL
            );
        },
        () => {
            return new TOAGameModeTransitionControllerWithView(
                [TombOfAkhenatenGameMode.RESPIN_SECOND, TombOfAkhenatenGameMode.NORMAL, TombOfAkhenatenGameMode.RESPIN_FIRST, TombOfAkhenatenGameMode.RESPIN_FINAL],
                TombOfAkhenatenGameMode.FREESPIN,
                new TombOfAkhenatenFreeSpinIntroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new TOAGameModeTransitionControllerWithView(
                [TombOfAkhenatenGameMode.RESPIN_FINAL, TombOfAkhenatenGameMode.NORMAL, TombOfAkhenatenGameMode.RESPIN_FIRST, TombOfAkhenatenGameMode.RESPIN_SECOND],
                TombOfAkhenatenGameMode.FREESPIN,
                new TombOfAkhenatenFreeSpinIntroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.RESPIN_FINAL,
                TombOfAkhenatenGameMode.NORMAL
            );
        },
        () => {
            return new GameModeTransitionControllerWithView(
                TombOfAkhenatenGameMode.FREESPIN,
                TombOfAkhenatenGameMode.NORMAL,
                new TombOfAkhenatenFreeSpinOutroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.FREESPIN,
                TombOfAkhenatenGameMode.FS_RESPIN_FIRST
            );
        },
        () => {
            return new GameModeTransitionControllerWithView(
                TombOfAkhenatenGameMode.FS_RESPIN_FIRST,
                TombOfAkhenatenGameMode.NORMAL,
                new TombOfAkhenatenFreeSpinOutroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.FS_RESPIN_FIRST,
                TombOfAkhenatenGameMode.FREESPIN
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.FS_RESPIN_FIRST,
                TombOfAkhenatenGameMode.FS_RESPIN_SECOND
            );
        },
        () => {
            return new GameModeTransitionControllerWithView(
                TombOfAkhenatenGameMode.FS_RESPIN_SECOND,
                TombOfAkhenatenGameMode.NORMAL,
                new TombOfAkhenatenFreeSpinOutroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.FS_RESPIN_SECOND,
                TombOfAkhenatenGameMode.FREESPIN
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.FS_RESPIN_SECOND,
                TombOfAkhenatenGameMode.FS_RESPIN_FINAL
            );
        },
        () => {
            return new GameModeTransitionControllerWithView(
                TombOfAkhenatenGameMode.FS_RESPIN_FINAL,
                TombOfAkhenatenGameMode.NORMAL,
                new TombOfAkhenatenFreeSpinOutroView(StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.FS_INTRO_OUTRO.name))
            );
        },
        () => {
            return new GameModeTransitionController(
                TombOfAkhenatenGameMode.FS_RESPIN_FINAL,
                TombOfAkhenatenGameMode.FREESPIN
            );
        }
    ];
    INDIVIDUAL_WIN_PRESENTATION: () => IndividualWinPresentationController;
    public static spinningPyramidController: SpinningPyramidController;

    constructor() {
        if (TombOfAkhenatenGameModuleConfig.instance) {
            throw new Error("TombOfAkhenatenGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    SERVER_PARSER: () => ServerDataParser = () => {
        return new TombOfAkhenatenServerDataParser();
    };

    PARSED_INIT_DATA: (data: any, dataParser: ServerDataParser) => ParsedInitData = (data, dataParser: ServerDataParser) => {
        return new TombOfAkhenatenParsedInitData(data, <TombOfAkhenatenServerDataParser>dataParser);
    };

    PARSED_GAME_DATA: (data: any, dataParser: ServerDataParser) => ParsedGameData = (data, dataParser: ServerDataParser) => {
        return new TombOfAkhenatenParsedGameData(data, <TombOfAkhenatenServerDataParser>dataParser);
    };

    REEL_PART_CREATOR: () => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName: string, reelId: number, state?: ISymbolStateConfig, size?: ISymbolSizeConfig): TombOfAkhenatenReelSymbol => {
                if (symName.indexOf("L") > -1) {
                    return new TOALowSymbol(symName, reelId, state, size);
                }
                if (symName === "W") {
                    return new TOAWildSymbol(symName, reelId, state, size);
                }
                if (symName.indexOf("S") > -1) {
                    return new TOAScatterSymbol(symName, reelId, state, size);
                }
                return new TombOfAkhenatenReelSymbol(symName, reelId, state, size);
            });
    };

    REEL_CONTROLLER: (reelId: number) => TombOfAkhenatenReelController = (reelId: number) => {
        return new TombOfAkhenatenReelController(reelId);
    };

    REELS: () => Reels = () => {
        return new TOATimelineReelsController();
    };

    SYMBOL_STATE_CREATOR: () => ReelSymbolStateCreator = () => {
        return new TombOfAkhenatenReelSymbolStateCreator();
    };

    REEL_AREA_VIEW: () => ReelAreaView = () => {
        return new TombOfAkhenatenReelAreaView();
    };

    GAME_FEATURE_CREATOR: () => void = () => {
        TombOfAkhenatenGameModuleConfig.soundManager = new SoundManager();
        TombOfAkhenatenGameModuleConfig.gameTweakerTest = new GameTweakerTest();

        TombOfAkhenatenGameModuleConfig.background = new StillImageBackground({
            layer: TombOfAkhenatenGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages: {
                NORMAL: {
                    image: TombOfAkhenatenGameAssets.MAIN_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                },
                RESPIN_FIRST: {
                    image: TombOfAkhenatenGameAssets.MAIN_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                },
                RESPIN_SECOND: {
                    image: TombOfAkhenatenGameAssets.MAIN_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                },
                RESPIN_FINAL: {
                    image: TombOfAkhenatenGameAssets.MAIN_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                },
                FREESPIN: {
                    image: TombOfAkhenatenGameAssets.BONUS_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                },
                FS_RESPIN_FIRST: {
                    image: TombOfAkhenatenGameAssets.BONUS_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                },
                FS_RESPIN_SECOND: {
                    image: TombOfAkhenatenGameAssets.BONUS_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                },
                FS_RESPIN_FINAL: {
                    image: TombOfAkhenatenGameAssets.BONUS_GAME_BACKGROUND,
                    offset: new PIXI.Point(-480, -480)
                }
            },
            stretch: false
        });

        new TombOfAkhenatenBackgroundView();
        new TOAScatterOverlayView();
        new StonePressView();
        new WaysUpdateView();
        TombOfAkhenatenGameModuleConfig.symFireOverlay = new SymbolsFireOverlayView();
        TombOfAkhenatenGameModuleConfig.reelDividerView = new ReelDividerView();
        TombOfAkhenatenGameModuleConfig.toaMultiplier = new TOAMultiplier();
        TombOfAkhenatenGameModuleConfig.toaWinCountUp = new TOAInitialWinCountUp();
        TombOfAkhenatenGameModuleConfig.toaBigWinView = new WinTextView();
        TombOfAkhenatenGameModuleConfig.toaCountupView = new CountUpView();
        TombOfAkhenatenGameModuleConfig.symbolStateHandler = new TOASymbolStateHandler();
        TombOfAkhenatenGameModuleConfig.shake = new TOAShakeEffect();
        TombOfAkhenatenGameModuleConfig.featurePrice = new FeaturePrice();
    };

    GAME_ROUND_CONFIG: () => GameRoundConfig = () => {
        TombOfAkhenatenGameModuleConfig.spinningPyramidController = new SpinningPyramidController();
        return {
            NORMAL: {
                idle: [],
                idleLoop: [
                    new BetWayWin(),
                    new TOASymbolIdleAnimController(),
                    new TOABackgroundIdleAnimController()
                ],
                starting: [
                    new SpinStart(true),

                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                    new ReelStart(7, 0),
                    new ReelStart(8, 0),
                    new ReelStart(9, 0),
                    new ReelStart(12, 0),
                    new ReelStart(13, 0),
                    new ReelStart(14, 0),
                    new ReelStart(17, 0),
                    new ReelStart(18, 0),
                    new ReelStart(19, 0),
                    new ReelStart(22, 0),
                    new ReelStart(23, 0),
                    new ReelStart(24, 0),
                ],
                stoppable: [
                    new TOANearWin(2),
                    new ReelStop(2),
                    new TOANearWin(3),
                    new ReelStop(3),
                    new TOANearWin(4),
                    new ReelStop(4),
                    new TOANearWin(7),
                    new ReelStop(7),
                    new TOANearWin(8),
                    new ReelStop(8),
                    new TOANearWin(9),
                    new ReelStop(9),
                    new TOANearWin(12),
                    new ReelStop(12),
                    new TOANearWin(13),
                    new ReelStop(13),
                    new TOANearWin(14),
                    new ReelStop(14),
                    new TOANearWin(17),
                    new ReelStop(17),
                    new TOANearWin(18),
                    new ReelStop(18),
                    new TOANearWin(19),
                    new ReelStop(19),
                    new TOANearWin(22),
                    new ReelStop(22),
                    new TOANearWin(23),
                    new ReelStop(23),
                    new TOANearWin(24),
                    new ReelStop(24),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            RESPIN_FIRST: {
                idle: [
                    new TombOfAkhenatenZeroBet()
                ],
                idleLoop: [
                    new BetWayWin()
                ],
                starting: [
                    new SpinStart(),

                    new ReelStart(1, 0),
                    new ReelStart(6, 0),
                    new ReelStart(11, 0),
                    new ReelStart(16, 0),
                    new ReelStart(21, 0)
                ],
                stoppable: [
                    new TOANearWin(1),
                    new ReelStop(1),
                    new TOANearWin(6),
                    new ReelStop(6),
                    new TOANearWin(11),
                    new ReelStop(11),
                    new TOANearWin(16),
                    new ReelStop(16),
                    new TOANearWin(21),
                    new ReelStop(21),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            RESPIN_SECOND: {
                idle: [
                    new TombOfAkhenatenZeroBet()
                ],
                idleLoop: [
                    new BetWayWin()
                ],
                starting: [
                    new SpinStart(),

                    new ReelStart(0, 0),
                    new ReelStart(5, 0),
                    new ReelStart(10, 0),
                    new ReelStart(15, 0),
                    new ReelStart(20, 0)
                ],
                stoppable: [
                    new TOANearWin(0),
                    new ReelStop(0),
                    new TOANearWin(5),
                    new ReelStop(5),
                    new TOANearWin(10),
                    new ReelStop(10),
                    new TOANearWin(15),
                    new ReelStop(15),
                    new TOANearWin(20),
                    new ReelStop(20),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            RESPIN_FINAL: {
                idle: [
                    new TombOfAkhenatenZeroBet()
                ],
                idleLoop: [
                    new BetWayWin()
                ],
                starting: [
                    // new SpinningPyramid(0, 0),
                    // new SpinningPyramid(1,0),
                    // new SpinningPyramid(2,0),
                    // new SpinningPyramid(3,0),
                    // new SpinningPyramid(4, 0),
                    TombOfAkhenatenGameModuleConfig.spinningPyramidController
                ],
                customStarting :[
                    new SpinStart(false, true),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                    new ReelStart(5, 0),
                    new ReelStart(6, 0),
                    new ReelStart(7, 0),
                    new ReelStart(8, 0),
                    new ReelStart(9, 0),
                    new ReelStart(10, 0),
                    new ReelStart(11, 0),
                    new ReelStart(12, 0),
                    new ReelStart(13, 0),
                    new ReelStart(14, 0),
                    new ReelStart(15, 0),
                    new ReelStart(16, 0),
                    new ReelStart(17, 0),
                    new ReelStart(18, 0),
                    new ReelStart(19, 0),
                    new ReelStart(20, 0),
                    new ReelStart(21, 0),
                    new ReelStart(22, 0),
                    new ReelStart(23, 0),
                    new ReelStart(24, 0),
                ],
                stoppable: [
                    new TOANearWin(0),
                    new ReelStop(0),
                    new TOANearWin(1),
                    new ReelStop(1),
                    new TOANearWin(2),
                    new ReelStop(2),
                    new TOANearWin(3),
                    new ReelStop(3),
                    new TOANearWin(4),
                    new ReelStop(4),
                    new TOANearWin(5),
                    new ReelStop(5),
                    new TOANearWin(6),
                    new ReelStop(6),
                    new TOANearWin(7),
                    new ReelStop(7),
                    new TOANearWin(8),
                    new ReelStop(8),
                    new TOANearWin(9),
                    new ReelStop(9),
                    new TOANearWin(10),
                    new ReelStop(10),
                    new TOANearWin(11),
                    new ReelStop(11),
                    new TOANearWin(12),
                    new ReelStop(12),
                    new TOANearWin(13),
                    new ReelStop(13),
                    new TOANearWin(14),
                    new ReelStop(14),
                    new TOANearWin(15),
                    new ReelStop(15),
                    new TOANearWin(16),
                    new ReelStop(16),
                    new TOANearWin(17),
                    new ReelStop(17),
                    new TOANearWin(18),
                    new ReelStop(18),
                    new TOANearWin(19),
                    new ReelStop(19),
                    new TOANearWin(20),
                    new ReelStop(20),
                    new TOANearWin(21),
                    new ReelStop(21),
                    new TOANearWin(22),
                    new ReelStop(22),
                    new TOANearWin(23),
                    new ReelStop(23),
                    new TOANearWin(24),
                    new ReelStop(24),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            FREESPIN: {
                idle: [
                    new TombOfAkhenatenZeroBet()
                ],
                idleLoop: [ new BetWayWin(),],
                starting: [
                    new SpinStart(true),

                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                    new ReelStart(7, 0),
                    new ReelStart(8, 0),
                    new ReelStart(9, 0),
                    new ReelStart(12, 0),
                    new ReelStart(13, 0),
                    new ReelStart(14, 0),
                    new ReelStart(17, 0),
                    new ReelStart(18, 0),
                    new ReelStart(19, 0),
                    new ReelStart(22, 0),
                    new ReelStart(23, 0),
                    new ReelStart(24, 0),
                ],
                stoppable: [
                    new TOANearWin(2),
                    new ReelStop(2),
                    new TOANearWin(3),
                    new ReelStop(3),
                    new TOANearWin(4),
                    new ReelStop(4),
                    new TOANearWin(7),
                    new ReelStop(7),
                    new TOANearWin(8),
                    new ReelStop(8),
                    new TOANearWin(9),
                    new ReelStop(9),
                    new TOANearWin(12),
                    new ReelStop(12),
                    new TOANearWin(13),
                    new ReelStop(13),
                    new TOANearWin(14),
                    new ReelStop(14),
                    new TOANearWin(17),
                    new ReelStop(17),
                    new TOANearWin(18),
                    new ReelStop(18),
                    new TOANearWin(19),
                    new ReelStop(19),
                    new TOANearWin(22),
                    new ReelStop(22),
                    new TOANearWin(23),
                    new ReelStop(23),
                    new TOANearWin(24),
                    new ReelStop(24),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        //new InitialWin(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            FS_RESPIN_FIRST: {
                idle: [
                    new TombOfAkhenatenZeroBet()
                ],
                idleLoop: [],
                starting: [
                    new SpinStart(),
                    new ReelStart(1, 0),
                    new ReelStart(6, 0),
                    new ReelStart(11, 0),
                    new ReelStart(16, 0),
                    new ReelStart(21, 0)
                ],
                stoppable: [
                    new TOANearWin(1),
                    new ReelStop(1),
                    new TOANearWin(6),
                    new ReelStop(6),
                    new TOANearWin(11),
                    new ReelStop(11),
                    new TOANearWin(16),
                    new ReelStop(16),
                    new TOANearWin(21),
                    new ReelStop(21),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        //new InitialWin(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            FS_RESPIN_SECOND: {
                idle: [
                    new TombOfAkhenatenZeroBet()
                ],
                idleLoop: [],
                starting: [
                    new SpinStart(),

                    new ReelStart(0, 0),
                    new ReelStart(5, 0),
                    new ReelStart(10, 0),
                    new ReelStart(15, 0),
                    new ReelStart(20, 0)
                ],
                stoppable: [
                    new TOANearWin(0),
                    new ReelStop(0),
                    new TOANearWin(5),
                    new ReelStop(5),
                    new TOANearWin(10),
                    new ReelStop(10),
                    new TOANearWin(15),
                    new ReelStop(15),
                    new TOANearWin(20),
                    new ReelStop(20),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        //new InitialWin(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            FS_RESPIN_FINAL: {
                idle: [
                    new TombOfAkhenatenZeroBet()
                ],
                idleLoop: [],
                starting: [
                    // new SpinningPyramid(0, 0),
                    // new SpinningPyramid(1,0),
                    // new SpinningPyramid(2,0),
                    // new SpinningPyramid(3,0),
                    // new SpinningPyramid(4, 0),
                    TombOfAkhenatenGameModuleConfig.spinningPyramidController
                ],
                customStarting :[
                    new SpinStart(false, true),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                    new ReelStart(5, 0),
                    new ReelStart(6, 0),
                    new ReelStart(7, 0),
                    new ReelStart(8, 0),
                    new ReelStart(9, 0),
                    new ReelStart(10, 0),
                    new ReelStart(11, 0),
                    new ReelStart(12, 0),
                    new ReelStart(13, 0),
                    new ReelStart(14, 0),
                    new ReelStart(15, 0),
                    new ReelStart(16, 0),
                    new ReelStart(17, 0),
                    new ReelStart(18, 0),
                    new ReelStart(19, 0),
                    new ReelStart(20, 0),
                    new ReelStart(21, 0),
                    new ReelStart(22, 0),
                    new ReelStart(23, 0),
                    new ReelStart(24, 0)
                ],
                stoppable: [
                    new TOANearWin(0),
                    new ReelStop(0),
                    new TOANearWin(1),
                    new ReelStop(1),
                    new TOANearWin(2),
                    new ReelStop(2),
                    new TOANearWin(3),
                    new ReelStop(3),
                    new TOANearWin(4),
                    new ReelStop(4),
                    new TOANearWin(5),
                    new ReelStop(5),
                    new TOANearWin(6),
                    new ReelStop(6),
                    new TOANearWin(7),
                    new ReelStop(7),
                    new TOANearWin(8),
                    new ReelStop(8),
                    new TOANearWin(9),
                    new ReelStop(9),
                    new TOANearWin(10),
                    new ReelStop(10),
                    new TOANearWin(11),
                    new ReelStop(11),
                    new TOANearWin(12),
                    new ReelStop(12),
                    new TOANearWin(13),
                    new ReelStop(13),
                    new TOANearWin(14),
                    new ReelStop(14),
                    new TOANearWin(15),
                    new ReelStop(15),
                    new TOANearWin(16),
                    new ReelStop(16),
                    new TOANearWin(17),
                    new ReelStop(17),
                    new TOANearWin(18),
                    new ReelStop(18),
                    new TOANearWin(19),
                    new ReelStop(19),
                    new TOANearWin(20),
                    new ReelStop(20),
                    new TOANearWin(21),
                    new ReelStop(21),
                    new TOANearWin(22),
                    new ReelStop(22),
                    new TOANearWin(23),
                    new ReelStop(23),
                    new TOANearWin(24),
                    new ReelStop(24),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new StonePress(),
                        //new InitialWin(),
                        new BetWayWinInitial(),
                        new NormalWin(),
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.normalWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], true)
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[0], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[1], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[2], TombOfAkhenatenGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
        }
    };
}